import Route from "vue-routisan";
import isAuthenticated from "../middlewares/isAuthenticated";
import isTransporter from "@/http/routes/middlewares/isTransporter";
import hasQuotationPermission from "@/http/routes/middlewares/hasPermission/hasQuotationPermission";

const options = {
  meta: {
    layout: () => import(/* webpackChunkName: "transporter" */ "@/resources/views/quotation/transporter/layout/Layout.vue")
  }
};

Route.group({}, () => {
  Route.group({prefix: "quotation", beforeEnter: [isTransporter]}, () => {
    Route.group({prefix: "transporter", beforeEnter: [isAuthenticated, hasQuotationPermission]}, () => {
      Route.redirect("/", to => {
        return {name: "transporter.quotation.order_quotes_transporter"};
      });
      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes_transporter"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderQuotesTransporter")
        ).name("transporter.quotation.order_quotes_transporter").options(options);
        Route.view("/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/QuoteDetailsTransporter")
        ).name("transporter.quotation.order_quotes_transporter_details").options(options);
      });

      Route.view("/shipping_request_quote", () =>
        import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/ShippingRequestQuote")
      ).name("transporter.quotation.order_shipping_request_quote").options(options);

      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES REQUESTER                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/OrderQuotes")
        ).name("transporter.quotation.order_quotes").options(options);
        Route.view("/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/QuoteDetails")
        ).name("transporter.quotation.order_quotes_details").options(options);
        Route.view("/transporters/:id", () =>
          import(/* webpackChunkName: "transporter" */ "@/resources/views/logistic_manager/transporter/order/QuoteDetailsTransporterRequester")
        ).name("transporter.quotation.order_quotes_details_transporters").options(options);
      });
    });
  });
});

export default Route.all();
